/** @format **/
import { DiscountCollectionInterface } from '../../interfaces/api/DiscountCollectionInterface';

export const ProductActions = {
    PRODUCT_REFRESH_VIEW: 'productRefresh',
    PRODUCT_ACTIVATE_COMPONENT_REQUEST: 'PRODUCT_ACTIVATE_COMPONENT_REQUEST',
    PRODUCT_ACTIVATE_COMPONENT_SELECTED: 'PRODUCT_ACTIVATE_COMPONENT_SELECTED',

    PRODUCT_GET_ALLOWED_DISCOUNT_LIST: 'PRODUCT_GET_ALLOWED_DISCOUNT_LIST',
    PRODUCT_PUT_ACTIVATE_DISCOUNT: 'PRODUCT_PUT_ACTIVATE_DISCOUNT',
    PRODUCT_PUT_CHANGE_VC: 'PRODUCT_PUT_CHANGE_VC',
};

export type ProductActionField = {
    type: string;
    action?: string;
    uri?: string;
    discounts?: DiscountCollectionInterface | null;
};

export type ProductComponent = {
    type: string;
    selectedValue?: number;
    componentName?: string;
    simCardId?: number;
    status?: number;
    params?: string;
};

export function productReducers(state: any, params: ProductActionField | ProductComponent): object {
    switch (params.type) {
        case ProductActions.PRODUCT_REFRESH_VIEW:
        case ProductActions.PRODUCT_ACTIVATE_COMPONENT_REQUEST:
        case ProductActions.PRODUCT_ACTIVATE_COMPONENT_SELECTED:
            return params;
        case ProductActions.PRODUCT_GET_ALLOWED_DISCOUNT_LIST:
            return {
                ...state,
                ...params,
            };
        default:
            return {
                ...state,
            };
    }
}
